import { Controller } from '@hotwired/stimulus';
import 'summernote/dist/summernote-bs4.css';
import $ from 'jquery';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = [
        'jobTypeSelect',
        'jobTypeOtherTextareaContainer',
        'remoteSelect',
        'remoteWorkDetailsContainer',
    ];

    connect() {
        // Setup conditional display logic
        // lets do onchange of the jobtypeselect if the value is 'other' show the textarea otherwise hide it
        this.jobTypeSelectTarget.addEventListener('change', () => {
            if (this.jobTypeSelectTarget.value === 'other') {
                this.jobTypeOtherTextareaContainerTarget.classList.remove('d-none');
            } else {
                this.jobTypeOtherTextareaContainerTarget.classList.add('d-none');
            }
        });

        this.remoteSelectTarget.addEventListener('change', () => {
            this.remoteWorkDetailsContainerTarget.classList.remove('d-none');
        });

        if (this.remoteSelectTarget.value) {
            this.remoteWorkDetailsContainerTarget.classList.remove('d-none');
        }

        this._initTooltips();

        if (this._isMobile()) {
            this._disableMobileKeyboardOnDropdowns();
        }

        // Listen to multiple Live Component events
        this.element.addEventListener('live:update-finish', () => this._initTooltips());
        this.element.addEventListener('live:render', () => this._initTooltips());

        // Also observe DOM changes to re-initialize tooltips
        this._setupMutationObserver();
    }

    disconnect() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    _setupMutationObserver() {
        this.observer = new MutationObserver(() => {
            this._initTooltips();
        });

        this.observer.observe(this.element, {
            childList: true,
            subtree: true,
        });
    }

    _initTooltips() {
        // Dispose existing tooltips first
        $(this.element).find('[data-bs-toggle="tooltip"]').tooltip('dispose');
        // Re-initialize tooltips after a small delay to ensure DOM is ready
        setTimeout(() => {
            $(this.element).find('[data-bs-toggle="tooltip"]').tooltip();
        }, 100);
    }

    handleSubmitClick(event) {
        event.preventDefault();
        this._syncAllSummernotes();
        this.element.requestSubmit();
    }

    syncBeforeAction() {
        this._syncAllSummernotes();
    }

    _syncAllSummernotes() {
        const app = this.application;
        const controllers = app.getControllerForElementAndIdentifier
            ? this.element.querySelectorAll('[data-controller*="summernote-textarea"]')
            : [];

        controllers.forEach((el) => {
            const ctrl = app.getControllerForElementAndIdentifier(el, 'summernote-textarea');
            if (ctrl) {
                ctrl.syncToLiveComponent();
            }
        });
    }

    _isMobile() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
            || ('ontouchstart' in window && window.innerWidth < 768);
    }

    _disableMobileKeyboardOnDropdowns() {
        this.element.addEventListener('autocomplete:pre-connect', (event) => {
            // Hide placeholder for specialismsAd field when options are selected
            if (event.target && event.target.id && event.target.id.includes('specialismsAd')) {
                event.detail.options.hidePlaceholder = true;
            }
        });

        this.element.addEventListener('autocomplete:connect', (event) => {
            const controlInput = event.detail.tomSelect.control_input;
            if (controlInput) {
                controlInput.readOnly = true;
            }
        });
    }
}